export default {
  title: 'DynamicLab Pro'
};
